<template>
  <div>
    <div v-if="noFormField" class="daterange-picker__container datepicker-cont">
      <date-picker prefix-class="searchie" :placeholder="placeholder" v-model="date" type="date" @change="updateDate" :range="range" inline></date-picker>
    </div>
    <div v-else class="form-control form-control-date" :class="[{'form-control-sm': small, 'px-2': small, 'py-0': small},placement]">
      <div v-click-away>
        <slot name="selector">
          <div class="datepicker" @click="datePickerState = !datePickerState">
            <svg v-if="!hideIcon" viewBox="0 0 24 24" class="mr-2" :class="{'icon-sm': small}"><use xlink:href="#icon-calendar-edit"></use></svg>
            {{ `${dateFormat}${type === 'time' && date ? 'h' : ''}` }}
            <svg v-if="withCaret" viewBox="0 0 24 24" class="icon-regular caret ml-auto"><use xlink:href="#icon-chevron-down"></use></svg>
          </div>
        </slot>
        <transition name="fade">
          <div v-if="datePickerState" class="daterange-picker__container">
            <!--
            <div class="daterange-picker__header pt-2">
              <svg viewBox="0 0 24 24" class="icon-regular"><use xlink:href="#icon-calendar-edit"></use></svg>
              <span>{{ dateLongFormat }}</span>
            </div>
            <hr class="divider my-2">
            -->
            <date-picker prefix-class="searchie" :placeholder="placeholder" v-model="date" :type="type" @change="updateDate" :range="range" inline :show-second="showSecond" :disabled-date="isPastDateDisabled"></date-picker>
          </div>
        </transition>
      </div>
    </div>
    <div class="datepicker-controls px-2 py-2" v-if="hasControls">
      <b-btn variant="secondary" @click="handleCancel">
        Cancel
      </b-btn>
      <b-btn variant="primary" @click="$emit('change', date)">
        Apply
      </b-btn>
    </div>
  </div>
</template>
<script>
  import DatePicker from 'vue2-datepicker';
  import moment from "@app2/utils/moment";
  import standardMoment from 'moment'

  export default {
    name: 'FormControlDate',
    components: {
      DatePicker
    },
    props: {
      value: {},
      placeholder: {},
      range: Boolean,
      type: {
        type: String,
        default: 'date'
      },
      small: {
        type: Boolean,
        default: true
      },
      placement: String,
      noFormField: Boolean,
      hasControls: Boolean,
      hideIcon: Boolean,
      withCaret: Boolean,
      icon: {
        type: String,
        default: 'calendar-edit'
      },
      utc: {
        type: Boolean,
        default: true
      },
      showSecond: {
        type: Boolean,
        default: true
      },
      disablePastDates: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        date: null,
        datePickerState: false,
      }
    },
    directives: {
      clickAway: {
        bind(el, binding, vnode) {
          el.clickOutsideEvent = (event) => {
            if (!(el == event.target || el.contains(event.target))) {
              vnode.context.datePickerState = false;
            }
          };
          document.body.addEventListener("click", el.clickOutsideEvent);
        },
        unbind(el) {
          document.body.removeEventListener(
            "click",
            el.clickOutsideEvent
          );
        }
      }
    },
    computed: {
      dateFormat() {
        if(this.date) {
          return `${moment(this.date).format((this.type === 'date') ? "MMM DD YYYY" : this.showSecond ? "HH:mm:ss" : "HH:mm")}`
        } else {
          return this.placeholder;
        }
      },
      dateLongFormat() {
        if(this.date) {
          return moment(this.date).format("MMMM DD YYYY")
        } else {
          return this.placeholder;
        }
      },
    },
    methods: {
      addZ(n){
        return n<10? '0'+n:''+n;
      },
      updateDate(date) {
        if (this.type !== 'time') {
          this.datePickerState = false;
        }
        let formattedDate = this.utc ? moment(date) : standardMoment(date);
        this.$emit('input', this.type === 'time' ? `${formattedDate.format("HH:mm:ss")}` : this.getDate(date));
        this.$emit('change')
      },
      getDate(date) {
        if(Array.isArray(date)) return
        return `${date.getFullYear()}-${this.addZ(date.getMonth()+1)}-${this.addZ(date.getDate())}`
      },
      togglePicker() {
        this.datePickerState = !this.datePickerState;
      },
      handleCancel() {
        this.$root.$emit('bv::hide::popover');
        this.$emit('cancel')
      },
      isPastDateDisabled(date) {
        if (!this.disablePastDates) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date < today;
      }
    },
    mounted() {
      this.$nextTick(() => {
        if ( this.value ) {
          let value = this.utc ? moment(this.value) : standardMoment(this.value);
          this.date = value;
        }
      });
    },
  }
</script>
